import { styled } from '@linaria/react'
import { useTranslation } from 'react-i18next'

import china from '../../assets/flags/china.webp'
import mexico from '../../assets/flags/mexico.webp'
import type { Language } from '../../types/common'

const Container = styled.div`
  gap: 40px;
  padding-top: 30px;
`

const Text = styled.button`
  transition: all 0.2s ease-in-out;
  font-size: 16px;
  font-family: 'Avenir-Light';
  display: flex;
  align-items: center;
  color: var(--secondary-txt);
  img {
    margin-right: 8px;
    margin-top: -1px;
    width: 25px;
  }
  &.active {
    color: var(--highlight);
  }
`

const LANGUAGES = [
  {
    icon: mexico,
    label: 'Español',
    code: 'es',
  },
  {
    icon: china,
    label: '中文',
    code: 'zh',
  },
]


const LanguageSelector = () => {
  const { i18n } = useTranslation()
  const { language, changeLanguage } = i18n

  const setLanguage = async (newLanguage: Language) => {
    await changeLanguage(newLanguage)
    document.documentElement.setAttribute('lang', newLanguage)
    window.location.reload()
  }

  return (
    <Container className="flx-ctr">
      {LANGUAGES.map(lang => (
        <Text
          key={lang.code}
          onClick={() => setLanguage(lang.code as Language)}
          className={language === lang.code ? 'active' : ''}>
          <img src={lang.icon} />
          {lang.label}
        </Text>
      ))}
    </Container>
  )
}

export default LanguageSelector
